import { LISTENING_OVERVIEW_MULTI_TOPIC } from '@/app/dashboards/utils/layouts/listening-overview-multi-topic.enum';
import { LISTENING_OVERVIEW_SINGLE_TOPIC } from '@/app/dashboards/utils/layouts/listening-overview-single-topic.enum';
import templateCardBlank from '@/assets/images/dashboards/template-card-blank.svg';
import templateCardChannel from '@/assets/images/dashboards/template-card-channel.svg';
import templateCardCompoverview from '@/assets/images/dashboards/template-card-compoverview.png';
import templateCardSocialoverview from '@/assets/images/dashboards/template-card-socialoverview.png';
import templatePreview360 from '@/assets/images/dashboards/template-preview-360.png';
import templatePreviewBlank from '@/assets/images/dashboards/template-preview-blank.png';
import templatePreviewBrandhealth from '@/assets/images/dashboards/template-preview-brandhealth.png';
import templatePreviewCompoverview from '@/assets/images/dashboards/template-preview-compoverview.png';
import templatePreviewFacebook from '@/assets/images/dashboards/template-preview-faceboook.png';
import templatePreviewInstagram from '@/assets/images/dashboards/template-preview-instagram.png';
import templatePreviewLinkedin from '@/assets/images/dashboards/template-preview-linkedin.png';
import templatePreviewPinterest from '@/assets/images/dashboards/template-preview-pinterest.png';
import templatePreviewTiktok from '@/assets/images/dashboards/template-preview-tiktok.png';
import templatePreviewTwitter from '@/assets/images/dashboards/template-preview-twitter.png';
import templatePreviewYoutube from '@/assets/images/dashboards/template-preview-youtube.png';
import blankOverview1x from '@/assets/images/dashboards/templates/blank-overview/1x.png';
import blankOverview2x from '@/assets/images/dashboards/templates/blank-overview/2x.png';
import blankOverview3x from '@/assets/images/dashboards/templates/blank-overview/3x.png';
import brandHealthOverview1x from '@/assets/images/dashboards/templates/brand-health-overview/1x.png';
import brandHealthOverview2x from '@/assets/images/dashboards/templates/brand-health-overview/2x.png';
import brandHealthOverview3x from '@/assets/images/dashboards/templates/brand-health-overview/3x.png';
import communityOverview1x from '@/assets/images/dashboards/templates/community-overview/1x.png';
import communityOverview2x from '@/assets/images/dashboards/templates/community-overview/2x.png';
import communityOverview3x from '@/assets/images/dashboards/templates/community-overview/3x.png';
import creatorOverview1x from '@/assets/images/dashboards/templates/creator-overview/1x.png';
import creatorOverview2x from '@/assets/images/dashboards/templates/creator-overview/2x.png';
import creatorOverview3x from '@/assets/images/dashboards/templates/creator-overview/3x.png';
import dashboardOverview1x from '@/assets/images/dashboards/templates/dashboard-overview/1x.png';
import dashboardOverview2x from '@/assets/images/dashboards/templates/dashboard-overview/2x.png';
import dashboardOverview3x from '@/assets/images/dashboards/templates/dashboard-overview/3x.png';
import facebookOverview1x from '@/assets/images/dashboards/templates/facebook-overview/1x.png';
import facebookOverview2x from '@/assets/images/dashboards/templates/facebook-overview/2x.png';
import facebookOverview3x from '@/assets/images/dashboards/templates/facebook-overview/3x.png';
import instagramOverview1x from '@/assets/images/dashboards/templates/instagram-overview/1x.png';
import instagramOverview2x from '@/assets/images/dashboards/templates/instagram-overview/2x.png';
import instagramOverview3x from '@/assets/images/dashboards/templates/instagram-overview/3x.png';
import linkedinOverview1x from '@/assets/images/dashboards/templates/linkedin-overview/1x.png';
import linkedinOverview2x from '@/assets/images/dashboards/templates/linkedin-overview/2x.png';
import linkedinOverview3x from '@/assets/images/dashboards/templates/linkedin-overview/3x.png';
import listeningOverview1x from '@/assets/images/dashboards/templates/listening-overview/1x.png';
import listeningOverview2x from '@/assets/images/dashboards/templates/listening-overview/2x.png';
import listeningOverview3x from '@/assets/images/dashboards/templates/listening-overview/3x.png';
import pinterestOverview1x from '@/assets/images/dashboards/templates/pinterest-overview/1x.png';
import pinterestOverview2x from '@/assets/images/dashboards/templates/pinterest-overview/2x.png';
import pinterestOverview3x from '@/assets/images/dashboards/templates/pinterest-overview/3x.png';
import socialCompetitiveOverview1x from '@/assets/images/dashboards/templates/social-competitive-overview/1x.png';
import socialCompetitiveOverview2x from '@/assets/images/dashboards/templates/social-competitive-overview/2x.png';
import socialCompetitiveOverview3x from '@/assets/images/dashboards/templates/social-competitive-overview/3x.png';
import socialOverview1x from '@/assets/images/dashboards/templates/social-overview/1x.png';
import socialOverview2x from '@/assets/images/dashboards/templates/social-overview/2x.png';
import socialOverview3x from '@/assets/images/dashboards/templates/social-overview/3x.png';
import tiktokOverview1x from '@/assets/images/dashboards/templates/tiktok-overview/1x.png';
import tiktokOverview2x from '@/assets/images/dashboards/templates/tiktok-overview/2x.png';
import tiktokOverview3x from '@/assets/images/dashboards/templates/tiktok-overview/3x.png';
import xOverview1x from '@/assets/images/dashboards/templates/x-overview/1x.png';
import xOverview2x from '@/assets/images/dashboards/templates/x-overview/2x.png';
import xOverview3x from '@/assets/images/dashboards/templates/x-overview/3x.png';
import youtubeOverview1x from '@/assets/images/dashboards/templates/youtube-overview/1x.png';
import youtubeOverview2x from '@/assets/images/dashboards/templates/youtube-overview/2x.png';
import youtubeOverview3x from '@/assets/images/dashboards/templates/youtube-overview/3x.png';
import { PRODUCT_MAP } from '@/models/auth/customer-plan.enum';
import { BRAND, ORGANIZATION, USER } from '@/models/auth/permissions.enum';
import { srcSet } from '@/utils/srcset';

import { CHILI_PIPER_FORMS_MAP } from '../../settings/constants';
import { BRAND_HEALTH_MULTI_BRAND } from './layouts/brand-health-multi-brand.enum';
import { BRAND_HEALTH_SINGLE_BRAND } from './layouts/brand-health-single-brand.enum';
import { COMMUNITY_MULTI_BRAND } from './layouts/community-multi-brand.enum';
import { COMMUNITY_SINGLE_BRAND } from './layouts/community-single-brand.enum';
import { COMPETITIVE_OVERVIEW_MULTI_BRAND } from './layouts/competitive-overview-multi-brand.enum';
import { CREATOR_OVERVIEW_MULTI_BRAND } from './layouts/creator-overview-multi-brand.enum';
import { CREATOR_OVERVIEW_MULTI_CREATOR } from './layouts/creator-overview-multi-creator-enum';
import { CREATOR_OVERVIEW_SINGLE_BRAND } from './layouts/creator-overview-single-brand.enum';
import { CREATOR_OVERVIEW_SINGLE_CREATOR } from './layouts/creator-overview-single-creator.enum';
import { FACEBOOK_OVERVIEW_MULTI_BRAND } from './layouts/facebook-overview-multi-brand.enum';
import { FACEBOOK_OVERVIEW_SINGLE_BRAND } from './layouts/facebook-overview-single-brand.enum';
import { INSTAGRAM_OVERVIEW_MULTI_BRAND } from './layouts/instagram-overview-multi-brand.enum';
import { INSTAGRAM_OVERVIEW_SINGLE_BRAND } from './layouts/instagram-overview-single-brand.enum';
import { LINKEDIN_OVERVIEW_MULTI_BRAND } from './layouts/linkedin-overview-multi-brand.enum';
import { LINKEDIN_OVERVIEW_SINGLE_BRAND } from './layouts/linkedin-overview-single-brand.enum';
import { PINTEREST_OVERVIEW_MULTI_BRAND } from './layouts/pinterest-overview-multi-brand.enum';
import { PINTEREST_OVERVIEW_SINGLE_BRAND } from './layouts/pinterest-overview-single-brand.enum';
import { SOCIAL_OVERVIEW_SINGLE_BRAND } from './layouts/social-overview-single-brand.enum';
import { TIKTOK_OVERVIEW_MULTI_BRAND } from './layouts/tiktok-overview-multi-brand.enum';
import { TIKTOK_OVERVIEW_SINGLE_BRAND } from './layouts/tiktok-overview-single-brand.enum';
import { TWITTER_OVERVIEW_MULTI_BRAND } from './layouts/twitter-overview-multi-brand.enum';
import { TWITTER_OVERVIEW_SINGLE_BRAND } from './layouts/twitter-overview-single-brand.enum';
import { YOUTUBE_OVERVIEW_MULTI_BRAND } from './layouts/youtube-overview-multi-brand.enum';
import { YOUTUBE_OVERVIEW_SINGLE_BRAND } from './layouts/youtube-overview-single-brand.enum';

export const TEMPLATE_UPGRADE_MAP = Object.freeze({
  brandHealth: {
    title: 'Available With <br/>Social Listening',
    description:
      'Check the pulse of your brand across channels with the Brand Health template. Available with the Social Listening add-on.',
    buttonNameOld: 'Start Free Trial',
    // #TODO: To Be Removed and renamed with feature flag removal ticket https://app.shortcut.com/dashhudson/story/120622/remove-feature-flag
    bannerButtonName: 'Try Social Listening',
    walnutTourLink:
      'https://www.dashsocial.com/interactive-demo/social-listening-product-demo?utm_medium=referral&utm_source=dh_platform&utm_campaign=sl_upgrade',
    chiliPiper: CHILI_PIPER_FORMS_MAP.socialListening.contact,
    product: PRODUCT_MAP.SOCIAL_LISTENING,
    popupName: 'startTrial',
  },
  competitiveOverview: {
    title: 'Competitive Reporting Available In Premium Analytics',
    description:
      'Easily benchmark and compare your performance against your competition with Competitive Dashboards. Available with Premium Analytics add-on.',
    buttonNameOld: 'Start Free Trial',
    // #TODO: To Be Removed and renamed with feature flag removal ticket https://app.shortcut.com/dashhudson/story/120622/remove-feature-flag
    bannerButtonName: 'Try Competitive',
    chiliPiper: CHILI_PIPER_FORMS_MAP.premiumAnalytics.competitors,
    product: PRODUCT_MAP.PREMIUM_ANALYTICS,
    popupName: 'startTrial',
  },
  communityOverview: {
    title: 'Community Reporting Available In Premium Analytics',
    description:
      'Easily benchmark and compare your performance against your competition with Community Dashboards. Available with Premium Analytics add-on.',
    buttonNameOld: 'Start Free Trial',
    bannerButtonName: 'Try Community',
    chiliPiper: CHILI_PIPER_FORMS_MAP.engage.community,
    product: PRODUCT_MAP.ENGAGE,
    popupName: 'startTrial',
  },
  listeningOverview: {
    bannerButtonName: 'Try Social Listening',
    chiliPiper: CHILI_PIPER_FORMS_MAP.socialListening.upgrade,
    product: PRODUCT_MAP.SOCIAL_LISTENING,
    popupName: 'startTrial',
  },
});

const getFacebookOverviewTemplate = () => ({
  id: 'facebookOverview',
  name: 'Facebook Overview',
  description:
    'Measure your most important Facebook metrics and view your content performance across brands.',
  legacyButtonName: 'Facebook Overview',
  bannerButtonName: 'Create Dashboard',
  cardImage: templateCardChannel,
  previewImage: templatePreviewFacebook,
  bannerSrc: facebookOverview1x,
  bannerSrcset: srcSet(facebookOverview1x, facebookOverview2x, facebookOverview3x),
  layouts: {
    singleBrand: FACEBOOK_OVERVIEW_SINGLE_BRAND,
    multiBrand: FACEBOOK_OVERVIEW_MULTI_BRAND,
  },
  channels: ['FACEBOOK'],
  allowContentTags: true,
});

const getTikTokOverviewTemplate = () => ({
  id: 'tikTokOverview',
  name: 'TikTok Overview',
  description:
    'Measure your most important TikTok metrics and view your content performance across brands.',
  legacyButtonName: 'TikTok Overview',
  bannerButtonName: 'Create Dashboard',
  cardImage: templateCardChannel,
  previewImage: templatePreviewTiktok,
  layouts: {
    singleBrand: TIKTOK_OVERVIEW_SINGLE_BRAND,
    multiBrand: TIKTOK_OVERVIEW_MULTI_BRAND,
  },
  bannerSrc: tiktokOverview1x,
  bannerSrcset: srcSet(tiktokOverview1x, tiktokOverview2x, tiktokOverview3x),
  channels: ['TIKTOK'],
  allowContentTags: true,
});

const getBrandHealthTemplate = () => ({
  id: 'brandHealth',
  name: 'Brand Health',
  description:
    'Measure how your posts are resonating with your audience by tracking overall sentiment and engagement.',
  legacyButtonName: 'Brand Health',
  bannerButtonName: 'Create Dashboard',
  cardImage: templateCardChannel,
  previewImage: templatePreviewBrandhealth,
  createdAt: 'April 24 2023 00:00:01 UTC',
  layouts: {
    singleBrand: BRAND_HEALTH_SINGLE_BRAND,
    multiBrand: BRAND_HEALTH_MULTI_BRAND,
  },
  bannerSrc: brandHealthOverview1x,
  bannerSrcset: srcSet(brandHealthOverview1x, brandHealthOverview2x, brandHealthOverview3x),
  iconOverrideList: [{ value: 'brandhealth', competitive: false }],
  brandPermissions: [BRAND.GENERAL.CAN_ACCESS_SENTIMENT],
  brandDisabledTooltip: 'This template is not included in this brand’s plan.',
  showUpgrade: true,
  channels: ['FACEBOOK', 'INSTAGRAM', 'TIKTOK', 'TWITTER', 'YOUTUBE'],
  upgradeOptions: TEMPLATE_UPGRADE_MAP.brandHealth,
  allowContentTags: true,
});

export const TEMPLATES = Object.freeze({
  blank: {
    id: 'blank',
    name: 'Blank Dashboard',
    description:
      'Build your Dashboard from scratch. Add the metrics, channels, and brands that matter most to your team.',
    legacyButtonName: 'Blank Dashboard',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardBlank,
    previewImage: templatePreviewBlank,
    bannerSrc: blankOverview1x,
    bannerSrcset: srcSet(blankOverview1x, blankOverview2x, blankOverview3x),
    channels: [],
    allowContentTags: false,
  },
  socialOverview: {
    id: 'socialOverview',
    name: '360 Social Overview',
    description: 'Get a holistic view of your social strategy across your most important channels.',
    legacyButtonName: '360 Social Overview',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardSocialoverview,
    previewImage: templatePreview360,
    layouts: {
      singleBrand: SOCIAL_OVERVIEW_SINGLE_BRAND,
    },
    bannerSrc: socialOverview1x,
    bannerSrcset: srcSet(socialOverview1x, socialOverview2x, socialOverview3x),
    channels: ['FACEBOOK', 'INSTAGRAM', 'LINKEDIN', 'PINTEREST', 'TIKTOK', 'TWITTER', 'YOUTUBE'],
    allowContentTags: true,
  },
  competitiveOverview: {
    id: 'competitiveOverview',
    name: 'Competitive Overview',
    description:
      'Track your performance against key competitors and the average of your competitive set.',
    legacyButtonName: 'Competitive',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardCompoverview,
    previewImage: templatePreviewCompoverview,
    bannerSrc: socialCompetitiveOverview1x,
    bannerSrcset: srcSet(
      socialCompetitiveOverview1x,
      socialCompetitiveOverview2x,
      socialCompetitiveOverview3x,
    ),
    createdAt: 'May 10 2022 00:00:01 UTC',
    layouts: {
      multiBrand: COMPETITIVE_OVERVIEW_MULTI_BRAND,
    },
    brandPermissions: [BRAND.COMPETITIVE.CAN_ACCESS_COMPETITORS],
    showUpgrade: true,
    userPermissions: [USER.COMPETITIVE.CAN_ACCESS_COMPETITORS],
    brandDisabledTooltip: 'This template is not included in this brand’s plan.',
    channels: ['INSTAGRAM'],
    upgradeOptions: TEMPLATE_UPGRADE_MAP.competitiveOverview,
    allowContentTags: true,
  },
  get brandHealth() {
    return getBrandHealthTemplate();
  },
  creatorsOverview: {
    id: 'creatorsOverview',
    name: 'Creators Overview',
    description:
      'Measure the performance of your Creators and the impact their posts have on your brands.',
    legacyButtonName: 'Creators Overview',
    bannerButtonName: 'Create Dashboard',
    previewImage: templatePreviewBlank,
    cardImage: templateCardChannel,
    bannerSrc: creatorOverview1x,
    bannerSrcset: srcSet(creatorOverview1x, creatorOverview2x, creatorOverview3x),
    layouts: {
      singleBrand: CREATOR_OVERVIEW_SINGLE_BRAND,
      multiBrand: CREATOR_OVERVIEW_MULTI_BRAND,
      singleCreator: CREATOR_OVERVIEW_SINGLE_CREATOR,
      multiCreator: CREATOR_OVERVIEW_MULTI_CREATOR,
    },
    channels: ['INSTAGRAM', 'TIKTOK'],
    allowContentTags: true,
  },
  communityOverview: {
    id: 'communityOverview',
    name: 'Community Overview',
    description: 'Measure your brand and team performance in Community across your social channels',
    bannerButtonName: 'Create Dashboard',
    bannerSrc: communityOverview1x,
    bannerSrcset: srcSet(communityOverview1x, communityOverview2x, communityOverview3x),
    channels: ['FACEBOOK', 'INSTAGRAM', 'TIKTOK', 'TWITTER', 'YOUTUBE'],
    allowContentTags: true,
    brandPermissions: [BRAND.COMMUNITY.CAN_ACCESS_COMMUNITY],
    upgradeOptions: TEMPLATE_UPGRADE_MAP.communityOverview,
    showUpgrade: true,
    layouts: {
      singleBrand: COMMUNITY_SINGLE_BRAND,
      multiBrand: COMMUNITY_MULTI_BRAND,
    },
  },
  listeningOverview: {
    id: 'listeningOverview',
    name: 'Social Listening Overview',
    description: 'Measure topic performance across social channels',
    bannerButtonName: 'Create Dashboard',
    bannerSrc: listeningOverview1x,
    bannerSrcset: srcSet(listeningOverview1x, listeningOverview2x, listeningOverview3x),
    channels: [
      'FACEBOOK',
      'INSTAGRAM',
      'LINKEDIN',
      'TIKTOK',
      'TWITTER',
      'YOUTUBE',
      'REDDIT',
      'WEB',
    ],
    allowContentTags: false,
    organizationPermissions: [ORGANIZATION.LISTENING.CAN_ACCESS_SOCIAL_LISTENING],
    upgradeOptions: TEMPLATE_UPGRADE_MAP.listeningOverview,
    showUpgrade: true,
    layouts: {
      singleTopic: LISTENING_OVERVIEW_SINGLE_TOPIC,
      multiTopic: LISTENING_OVERVIEW_MULTI_TOPIC,
    },
  },
  get tikTokOverview() {
    return getTikTokOverviewTemplate();
  },
  instagramOverview: {
    id: 'instagramOverview',
    name: 'Instagram Overview',
    description:
      'Measure your most important Instagram metrics and view your content performance across brands.',
    legacyButtonName: 'Instagram Overview',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardChannel,
    previewImage: templatePreviewInstagram,
    bannerSrc: instagramOverview1x,
    bannerSrcset: srcSet(instagramOverview1x, instagramOverview2x, instagramOverview3x),
    layouts: {
      singleBrand: INSTAGRAM_OVERVIEW_SINGLE_BRAND,
      multiBrand: INSTAGRAM_OVERVIEW_MULTI_BRAND,
    },
    channels: ['INSTAGRAM'],
    allowContentTags: true,
  },
  get facebookOverview() {
    return getFacebookOverviewTemplate();
  },
  pinterestOverview: {
    id: 'pinterestOverview',
    name: 'Pinterest Overview',
    description:
      'Measure your most important Pinterest metrics and view your content performance across brands.',
    legacyButtonName: 'Pinterest Overview',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardChannel,
    previewImage: templatePreviewPinterest,
    bannerSrc: pinterestOverview1x,
    bannerSrcset: srcSet(pinterestOverview1x, pinterestOverview2x, pinterestOverview3x),
    layouts: {
      singleBrand: PINTEREST_OVERVIEW_SINGLE_BRAND,
      multiBrand: PINTEREST_OVERVIEW_MULTI_BRAND,
    },
    channels: ['PINTEREST'],
    allowContentTags: true,
  },
  twitterOverview: {
    id: 'twitterOverview',
    name: 'X Overview',
    description:
      'Measure your most important X metrics and view your content performance across brands.',
    legacyButtonName: 'X Overview',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardChannel,
    previewImage: templatePreviewTwitter,
    bannerSrc: xOverview1x,
    bannerSrcset: srcSet(xOverview1x, xOverview2x, xOverview3x),
    layouts: {
      singleBrand: TWITTER_OVERVIEW_SINGLE_BRAND,
      multiBrand: TWITTER_OVERVIEW_MULTI_BRAND,
    },
    channels: ['TWITTER'],
    allowContentTags: true,
  },
  youtubeOverview: {
    id: 'youtubeOverview',
    name: 'YouTube Overview',
    description:
      'Measure your most important YouTube metrics and view your content performance across brands.',
    legacyButtonName: 'YouTube Overview',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardChannel,
    previewImage: templatePreviewYoutube,
    bannerSrc: youtubeOverview1x,
    bannerSrcset: srcSet(youtubeOverview1x, youtubeOverview2x, youtubeOverview3x),
    createdAt: 'May 17 2023 00:00:01 UTC',
    layouts: {
      singleBrand: YOUTUBE_OVERVIEW_SINGLE_BRAND,
      multiBrand: YOUTUBE_OVERVIEW_MULTI_BRAND,
    },
    channels: ['YOUTUBE'],
  },
  linkedinOverview: {
    id: 'linkedinOverview',
    name: 'LinkedIn Overview',
    description:
      'Measure your most important LinkedIn metrics and view your content performance across brands.',
    legacyButtonName: 'LinkedIn Overview',
    bannerButtonName: 'Create Dashboard',
    cardImage: templateCardChannel,
    previewImage: templatePreviewLinkedin,
    bannerSrc: linkedinOverview1x,
    bannerSrcset: srcSet(linkedinOverview1x, linkedinOverview2x, linkedinOverview3x),
    createdAt: 'June 3 2024 00:00:01 UTC',
    layouts: {
      singleBrand: LINKEDIN_OVERVIEW_SINGLE_BRAND,
      multiBrand: LINKEDIN_OVERVIEW_MULTI_BRAND,
    },
    channels: ['LINKEDIN'],
    allowContentTags: true,
  },
});

export const DASHBOARD_TEMPLATE_OVERVIEW = Object.freeze({
  bannerSrc: dashboardOverview1x,
  bannerSrcset: srcSet(dashboardOverview1x, dashboardOverview2x, dashboardOverview3x),
});
